import React, { useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MessageSquare, X } from 'lucide-react';
import { FeedbackFlow } from '../Feedback/FeedbackFlow';
interface FeedbackModalProps {
  isOpen: boolean;
  onClose: () => void;
  milestone?: number | null;
  milestoneType?: 'scan' | 'rewrite' | null;
}
export function FeedbackModal({
  isOpen,
  onClose,
  milestone = null,
  milestoneType = 'scan'
}: FeedbackModalProps) {
  const milestoneLabel = milestone ? milestoneType === 'rewrite' ? `Rewrite ${milestone} complete` : `Scan ${milestone} complete` : 'Share your story';
  useEffect(() => {
    if (!isOpen) return;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [isOpen]);
  return <AnimatePresence data-id="element-2140" data-mp="v5bt8s5sv2cg">
      {isOpen && <div className="fixed inset-0 z-[99999] flex items-center justify-center p-4" data-id="element-2141" data-mp="q9mswmlyhhf3">
          <motion.button type="button" aria-label="Close feedback modal" className="absolute inset-0 cursor-default bg-black/85 backdrop-blur-sm" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} data-id="element-2142" data-mp="bark6q8ok3l7" />

          <motion.section role="dialog" aria-modal="true" aria-labelledby="smart-feedback-title" initial={{
        opacity: 0,
        scale: 0.96,
        y: 16
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.96,
        y: 16
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative max-h-[92vh] w-full max-w-lg overflow-y-auto border border-red-500/40 bg-[#050505] p-6 shadow-2xl sm:p-8" data-id="element-2143" data-mp="u7st2m5cunuf">
            <div className="absolute left-0 top-0 h-1 w-full bg-[#FF0000]" data-id="element-2144" data-mp="3a1srmwj8arw7" />
            <div className="pointer-events-none absolute left-0 top-0 h-6 w-6 border-l-2 border-t-2 border-[#FF0000]" data-id="element-2145" data-mp="3nse9qj0uyxt1" />
            <div className="pointer-events-none absolute right-0 top-0 h-6 w-6 border-r-2 border-t-2 border-[#FF0000]" data-id="element-2146" data-mp="3iz306a4nw2xf" />
            <div className="pointer-events-none absolute bottom-0 left-0 h-6 w-6 border-b-2 border-l-2 border-[#FF0000]" data-id="element-2147" data-mp="1lzb4howdgf5" />
            <div className="pointer-events-none absolute bottom-0 right-0 h-6 w-6 border-b-2 border-r-2 border-[#FF0000]" data-id="element-2148" data-mp="akko7xblo38j" />

            <button type="button" onClick={onClose} className="absolute right-4 top-4 rounded p-2 text-gray-500 transition-colors duration-150 ease-out hover:text-white focus:outline-none focus:ring-2 focus:ring-[#FF0000]" aria-label="Close feedback modal" data-id="element-2149" data-mp="6kakysf6zqxd">
              <X size={20} data-id="element-2150" data-mp="1y7h0sdwjuswd" />
            </button>

            <header className="mb-7 pr-10" data-id="element-2151" data-mp="228sh1stja1rw">
              <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-full border border-red-500/40 bg-red-500/10" data-id="element-2152" data-mp="227r7jss61nca">
                <MessageSquare className="text-[#FF0000]" size={20} aria-hidden="true" data-id="element-2153" data-mp="1tfyz1nmpcoac" />
              </div>
              <p className="mb-2 font-mono text-[10px] font-bold uppercase tracking-[0.22em] text-[#FF0000]" data-id="element-2154" data-mp="1ekss8yfs8lfy">
                {milestoneLabel}
              </p>
              <h2 id="smart-feedback-title" className="text-2xl font-black uppercase tracking-tight text-white" data-id="element-2155" data-mp="15j1ohz4syooq">
                How was your experience?
              </h2>
              <p className="mt-2 text-sm leading-relaxed text-gray-400" data-id="element-2156" data-mp="2zwkhcvnw1j3p">
                Your honest feedback helps us make the experience clearer and
                more useful.
              </p>
            </header>

            <FeedbackFlow idPrefix="smart-feedback" contextLabel={milestone ? milestoneLabel : null} onTrustpilotClick={onClose} data-id="element-2157" data-mp="14qs42qm7x39g" />
          </motion.section>
        </div>}
    </AnimatePresence>;
}